import { Dictionary } from 'lodash'

export const REQUESTED_USERS = 'users/REQUESTED'
export const REQUESTED_USERS_FAILED = 'users/FAILED'
export const REQUESTED_USERS_SUCCEEDED = 'users/SUCCEEDED'
export const RECEIVED_USERS = 'users/RECEIVED'
export const FETCH_USERS = 'users/FETCH'

export const REQUESTED_USER = 'user/REQUESTED'
export const REQUESTED_USER_FAILED = 'user/FAILED'
export const REQUESTED_USER_SUCCEEDED = 'user/SUCCEEDED'
export const RECEIVED_USER = 'user/RECEIVED'
export const FETCH_USER = 'user/FETCH'
export const LOGIN_USER = 'user/LOGIN'
export const LOGOUT_USER = 'user/LOGOUT'
export const RESET_USER = 'user/RESET'

// MFA action types
export const MFA_REQUIRED = 'user/MFA_REQUIRED'
export const MFA_VERIFY = 'user/MFA_VERIFY'
export const MFA_VERIFY_SUCCESS = 'user/MFA_VERIFY_SUCCESS'
export const MFA_VERIFY_FAILED = 'user/MFA_VERIFY_FAILED'
export const MFA_RESET = 'user/MFA_RESET'

// Password action types
export const FORGOT_PASSWORD = 'user/FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'user/FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILED = 'user/FORGOT_PASSWORD_FAILED'
export const FORGOT_PASSWORD_RESET = 'user/FORGOT_PASSWORD_RESET'
export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'user/CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILED = 'user/CHANGE_PASSWORD_FAILED'
export const CHANGE_PASSWORD_RESET = 'user/CHANGE_PASSWORD_RESET'

export enum AuthStatus {
  MFA_REQUIRED = 'mfa_required',
  AUTHENTICATED = 'authenticated',
  PASSWORD_RESET = 'password_reset',
  PASSWORD_CHANGED = 'password_changed',
}

export enum UserRoles {
  admin = 'admin',
  contentReviewer = 'content-reviewer',
  dataSpecialist = 'data-specialist',
  academicHead = 'academic-head',
  videoEditor = 'video-editor',
  videoManager = 'video-manager',
}

// Categorized User Roles
export const userRoles = {
  superAdmins: [String(UserRoles.admin)],
  admins: [String(UserRoles.admin), String(UserRoles.academicHead)],
  users: [String(UserRoles.dataSpecialist), String(UserRoles.contentReviewer)],
  videoAdmins: [
    String(UserRoles.admin),
    String(UserRoles.videoManager),
    String(UserRoles.academicHead),
  ],
  videoUsers: [
    String(UserRoles.videoEditor),
    String(UserRoles.admin),
    String(UserRoles.videoManager),
    String(UserRoles.academicHead),
  ],
  all: [
    String(UserRoles.admin),
    String(UserRoles.academicHead),
    String(UserRoles.contentReviewer),
    String(UserRoles.dataSpecialist),
  ],
}

export interface UserActionImpl {
  type: string
  payload?: UserImpl | UsersImpl | UserPartialImpl[] | LoginImpl | LogoutImpl
}

export interface UserPartialImpl {
  id: number
  username: string
  role?: string
}

export interface UsersImpl {
  entities: Dictionary<UserPartialImpl>
  allIds: string[]
  adminIds: string[]
  reviewerIds: string[]
  specialistIds: string[]
  users: UserPartialImpl[]
}

export interface UserImpl {
  id: string
  name: string
  username?: string
  isVerified: Boolean
  role: UserRoles | null
  groups?: string[]
  email: string
  avatar: string
  authorized: boolean
  isLoading: boolean
  hasError: boolean
  permissions?: any
  requestedPath: string
  phone: string
  firstName: string
  lastName: string
  displayName: string
  contentPartnerId: number | null
  contentPartnerName: string | null
}

export interface IVertical {
  name: string,
  value: string,
}

export interface LoginImpl {
  phone: string
  password: string
}

export interface LogoutImpl {
  shouldCallAPI: Boolean
}

export interface MfaState {
  mfaRequired: boolean
  mfaId: string | null
  mfaMethod: string | null
  mfaSetupRequired: boolean
  setupUri: string | null
  passwordChangeRequired: boolean
  isVerifying: boolean
  verifyError: string | null
}

export interface MfaRequiredPayload {
  mfaId: string
  mfaMethod: string
  mfaSetupRequired: boolean
  setupUri: string | null
  passwordChangeRequired: boolean
}

export interface MfaVerifyPayload {
  mfaId: string
  mfaMethod: string
  code: string
  newPassword?: string
  confirmPassword?: string
}

export interface ForgotPasswordPayload {
  phone: string
  code: string
  newPassword: string
  confirmPassword: string
}

export interface ForgotPasswordState {
  isLoading: boolean
  isSuccess: boolean
  error: string | null
}

export interface ChangePasswordPayload {
  currentPassword: string
  newPassword: string
  confirmPassword: string
  code: string
}

export interface ChangePasswordState {
  isLoading: boolean
  isSuccess: boolean
  error: string | null
}

export interface UserFilter {
  username?: string
  questionReportAccess?: boolean
}

export interface UserGetAction {
  type: string
  payload: { filter: UserFilter }
}
